import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Icon from 'components/icon/Icon';
import { PATH_ROUTES } from 'routes/path';
import { buttonVariants } from 'components/ui/button';

export default function GenerateLabReport() {
  const { t } = useTranslation();

  const renderGenerateButton = () => {
    return (
      <Link
        to={PATH_ROUTES.GENERATE_LAB_REPORT}
        className={buttonVariants({
          variant: 'default',
          className:
            'w-full h-16 !bg-blue-600 !rounded-2xl !hover:bg-blue-600/90',
        })}
      >
        <Icon icon='scan-report' size={28} />
        <span className='ml-4 font-semibold leading-tight text-left whitespace-pre'>
          {t('scan_new_report')}
        </span>
      </Link>
    );
  };

  return (
    <div>
      <div className='max-w-xl mx-auto lg:hidden'>{renderGenerateButton()}</div>

      <div className='hidden px-6 py-4 space-y-6 bg-blue-100 rounded-2xl lg:block'>
        <div className='space-y-3'>
          <div className='flex items-center justify-between gap-x-4'>
            <h2 className='text-xl font-semibold leading-tight text-blue-500'>
              {t('got_health_updates')}
            </h2>

            <Icon icon='microscope' size={30} className='shrink-0' />
          </div>
          <p className='font-medium leading-tight'>
            {t('click_below_to_scan')}
          </p>
        </div>
        {renderGenerateButton()}
      </div>
    </div>
  );
}
